(async () => {
  // Unregister Service Worker.
  // https://stackoverflow.com/questions/33704791/how-do-i-uninstall-a-service-worker
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    if (registrations.length) {
      registrations.forEach((registration) => registration.unregister());

      // Delete caches.
      // https://stackoverflow.com/questions/45467842/how-to-clear-cache-of-service-worker
      const keys = await caches.keys();
      keys.forEach((key) => caches.delete(key));

      // Reload the current page without the browser HTTP cache.
      window.location.reload(true);
    }
  }
})();
